import axios from '@axios'
import JwtService from './jwtService'

const jwt = new JwtService(axios, {})

export default jwt
